import { useContext } from 'react';
import EntityFormContext from './EntityFormContext';
export default function useEntityFormContext() {
    return useContext(EntityFormContext);
}
